import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from "next/link";
import { memo } from "react";
export const ReCaptchaTermsInfo = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("p", {
        className: "text-12 text-pigeon-500",
        children: [
            "This site is protected by reCAPTCHA and the Google",
            " ",
            /*#__PURE__*/ _jsx(Link, {
                href: "https://policies.google.com/privacy",
                target: "_blank",
                className: "text-pigeon-500 underline",
                children: "Privacy Policy"
            }),
            " ",
            "and",
            " ",
            /*#__PURE__*/ _jsx(Link, {
                href: "https://policies.google.com/terms",
                target: "_blank",
                className: "text-pigeon-500 underline",
                children: "Terms of Service"
            }),
            " ",
            "apply."
        ]
    });
});
ReCaptchaTermsInfo.displayName = "ReCaptchaTermsInfo";
